<template lang="html">
  <div class="pageContainer d-none">
      <div class="container">


        <div id="HeaderRow" class="row">
          <div class="col-sm-12">
            <h1>{{ this.goal.title }}<small><span class="badge badge-primary badge-pill">Weekly Goal: {{ goal.frequencyGoal }}</span>{{ this.goal.description }}</small></h1>
          </div>
        </div>

        <div id="BodyRow" class="row">
          <div class="col-sm-3">
            <div class="list-group">
              <a href="#" class="list-group-item list-group-item-action">Dapibus ac facilisis in</a>
              <a href="#" class="list-group-item list-group-item-action">Morbi leo risus</a>
              <a href="#" class="list-group-item list-group-item-action">Porta ac consectetur ac</a>
              <a href="#" class="list-group-item list-group-item-action">Vestibulum at eros</a>
            </div>
          </div>
          <div class="col-sm-5">

            <Post />

          </div>
          <div class="col-sm-4">
            <div class="chartWrapper">
              <div class="row">
                <div class="col-6">
                  <h3>Weekly Progress</h3>
                </div>
                <div class="col-sm-6">
                  <div id="timeframeButtons" class="btn-group float-right" role="group" aria-label="Basic example">
                    <button id="year" @click.prevent="updateTimeframe(52)" type="button" class="btn btn-sm btn-light">1Y</button>
                    <button id="half" @click.prevent="updateTimeframe(26)" type="button" class="btn btn-sm btn-light">6M</button>
                    <button id="quarter" @click.prevent="updateTimeframe(12)" type="button" class="btn btn-sm btn-light">3M</button>
                    <button id="month" @click.prevent="updateTimeframe(4)" type="button" class="btn btn-sm btn-secondary">1M</button>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <canvas id="myChart" width="400" height="200"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Bar, mixins } from 'vue-chartjs'
import db from '@/store/firebaseinit'
import firebase from 'firebase'
import Navbar from '@/components/utility/Navbar'
import Post from '@/components/utility/Post'
import moment from 'moment'
import VueTextareaAutosize from 'vue-textarea-autosize'

export default {
  name: 'SingleGoal',
  components: {
    Navbar,
    Post,
    VueTextareaAutosize
  },
  data () {
    return {
      goal: {
        title: '',
        description: '',
        frequencyGoal: '',
      },
      goalHistoryData: null,
      labels: [],
      chart: null,
      chartDrawn: false,
      weekFrequencyMet: [],
      weekFrequencyGoal: [],
      weekColor: [],
      weekBorderColor: [],
      weekStart: null,
      timeFrame: [],
      graphItemClicked: null,
      mainComment: null,
    }
  },
  created() {
    Vue.use(VueTextareaAutosize)
    db.collection('goals').doc(this.$route.params.id).get()
    .then(result => {
      this.goal = result.data()
      $('.pageContainer').removeClass('d-none')
    }).catch(error => {

    })
    this.createChart(4)
  },
  methods: {
    updateTimeframe(amountOfWeeks) {
      $('#timeframeButtons button').removeClass('btn-secondary').addClass('btn-light')
      switch(amountOfWeeks) {
        case 4:
          $('#timeframeButtons #month').removeClass('btn-light').addClass('btn-secondary')
          break
        case 12:
          $('#timeframeButtons #quarter').removeClass('btn-light').addClass('btn-secondary')
          break
        case 26:
          $('#timeframeButtons #half').removeClass('btn-light').addClass('btn-secondary')
          break
        case 52:
          $('#timeframeButtons #year').removeClass('btn-light').addClass('btn-secondary')
          break
        default:
          $('#timeframeButtons #all').removeClass('btn-light').addClass('btn-secondary')
          break
      }
      this.createChart(amountOfWeeks)
    },
    createChart(amountOfWeeks) {
      this.timeFrame = []
      this.weekStart = null
      this.labels = []
      this.weekFrequencyMet = []
      this.weekFrequencyGoal = []
      this.weekColor = []
      this.weekBorderColor = []

      // Set timeframe array to the amount of past Monday's requested
      var mondayCalc = moment().format('E') - 1
      this.weekStart = moment().add(-mondayCalc, 'days').format('YYYY-MM-DD')
      for(var i = 0; i < amountOfWeeks; i++) {
        this.timeFrame[this.weekStart] = { 'frequencyGoal': 0, 'frequencyMet': 0 }
        this.weekStart = moment(this.weekStart).add(-7, 'days').format('YYYY-MM-DD')
        if(i == (amountOfWeeks - 1)) {
          db.collection('goalHistory').doc(this.$route.params.id).get()
          .then(result => {
            this.goalHistoryData = result.data()
            const week = Object.entries(this.goalHistoryData)
            const weekData = Object.entries(week[2][1])
            var weekDataLoop = 0

            weekData.forEach(doc => {
              weekDataLoop++
              if(doc[0] in this.timeFrame) {
                this.timeFrame[doc[0]]['frequencyMet'] = doc[1]['frequencyMet']
                this.timeFrame[doc[0]]['frequencyGoal'] = doc[1]['frequencyGoal']
                if(weekData.length == weekDataLoop) {
                  var updateArrayDataLoop = 0
                  for(var key in this.timeFrame) {
                    updateArrayDataLoop++
                    var label = moment(key).format("MM/D/YY")
                    this.labels.unshift(label)
                    this.weekFrequencyGoal.unshift(this.timeFrame[key]['frequencyGoal'])
                    this.weekFrequencyMet.unshift(this.timeFrame[key]['frequencyMet'])
                    if(this.timeFrame[key]['frequencyGoal'] > this.timeFrame[key]['frequencyMet']) {
                      this.weekColor.unshift('rgba(246,75,99,0.45)')
                      this.weekBorderColor.unshift('red')
                    } else {
                      this.weekColor.unshift('rgba(75, 180, 246, 0.45)')
                      this.weekBorderColor.unshift('rgba(70, 154, 208)')
                    }
                    if(updateArrayDataLoop == amountOfWeeks) {
                      if(this.chartDrawn) {
                        this.updateChart()
                      } else {
                        this.drawChart()
                      }
                    }
                  }

                }
              }
            })

          }).catch(error => {
            console.log(error)
          })

        }
      }
    },
    updateChart() {
      this.chart.data.labels = this.labels
      this.chart.data.datasets[0].data = this.weekFrequencyGoal
      this.chart.data.datasets[1].data = this.weekFrequencyMet
      this.chart.data.datasets[1].backgroundColor = this.weekColor
      this.chart.data.datasets[1].borderColor = this.weekBorderColor
      this.chart.update()
    },
    drawChart() {
      this.chartDrawn = true
      var ctx = document.getElementById("myChart").getContext("2d");
      this.chart = new Chart(ctx, {
          type: 'bar',
          data: {
              labels: this.labels,
              datasets: [
                {
                  label: 'Goal',
                  data: this.weekFrequencyGoal,
                  type: 'line',
                  fill: 'none',
                  borderColor: 'rgba(163, 163, 163, 0.45)',
                  borderWidth: 3,
                  cubicInterpolationMode: 'monotone'
              },
                {
                  label: 'Actual',
                  data: this.weekFrequencyMet,
                  backgroundColor: this.weekColor,
                  borderColor: this.weekBorderColor,
                  borderWidth: 0.5,
              }

            ]
          },
          options: {
            'onClick' : (evt, item) => {
              var activeElement = this.chart.getElementAtEvent(evt);
              this.getWeekInfo(evt, item)
            },
            legend: {
            display: false
         },
              scales: {
                  yAxes: [{
                      ticks: {
                          beginAtZero:true,
                          stepSize: 1,
                      }
                  }]
              }
          }

      });
    },
    getWeekInfo(evt, item) {
      if(item[1]) {
        var label = item[1]._model.label
        label = label.split('/')
        var date = moment().set({'year': '20'+label[2], 'month': label[0] - 1, 'date': label[1]}).format('YYYY-MM-DD')
        console.log(date)
      }
    },
  },
}
</script>

<style scoped>
  #HeaderRow {
    margin-bottom: 25px;
  }
  #BodyRow {

  }
  h1 {
    margin-top: 25px;
  }
  h1 small {
    display: block;
    font-size: 19px;
    margin-top: 8px;
  }
  h1 small span {
    margin-right: 10px;
  }
  button {
    outline: none;
  }
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
  .btn-sm {
    padding: 0.10rem .4rem;
    font-size: .7rem;
  }
  .chartWrapper {
    max-width: 500px;
    background: #fff;
    padding: 15px;
    border-radius: 5px;
    margin: auto;
    -webkit-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
    -moz-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
    box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
    border: 1px dotted #c9c9c9;
  }
  h3 {
    padding: 3px 0 12px 5px;
    font-size: 17px;
  }
  body {
    background: #efefef;
  }

</style>



// WEBPACK FOOTER //
// src/components/goals/SingleGoal.vue